import cn from "classnames";
import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { setAsReceived, setAsViewed } from "sources/books/popups";

const PopupStickers = ({ items, deactivatePopup }) => {
    return (
        <div className="popups-list">
            {items.map((item) => (
                <StickerItem key={item.id} {...item} deactivatePopup={deactivatePopup} />
            ))}
        </div>
    );
};

const StickerItem = ({ text, id, deactivatePopup, noWayToClose }) => {
    useEffect(() => {
        setAsReceived({ id });
    }, []);
    const [hovered, setHovered] = useState(false);

    const isMouseInBound = (ev) => {
        if (!noWayToClose) {
            return;
        }
        setHovered(true);
        const eleBounds = ev.target.getBoundingClientRect();
        const isEventInElement = (event) => {
            const x = event.clientX;
            if (x < eleBounds.left || x >= eleBounds.right) {
                return false;
            }
            const y = event.clientY;
            if (y < eleBounds.top || y >= eleBounds.bottom) {
                return false;
            }
            return true;
        };
        const handleMouseMove = (e) => {
            if (!isEventInElement(e)) {
                setHovered(false);
                document.removeEventListener("mousemove", handleMouseMove);
            }
        };
        document.addEventListener("mousemove", handleMouseMove);
    };

    return (
        <div
            className={cn("popups-item", { "popups-item--hidden": hovered, "popups-item--overflow": !noWayToClose })}
            onMouseEnter={isMouseInBound}
        >
            {!noWayToClose && (
                <div
                    className="popups-item__close close"
                    onClick={() => {
                        setAsViewed({ id });
                        deactivatePopup({ id });
                    }}
                />
            )}
            {noWayToClose ? (
                <div className="popups-item__body" dangerouslySetInnerHTML={{ __html: text }} />
            ) : (
                <Scrollbars autoHeight>
                    <div className="popups-item__body" dangerouslySetInnerHTML={{ __html: text }} />
                </Scrollbars>
            )}
        </div>
    );
};

export default PopupStickers;
